export const VERIFICATION_LEVEL_0 = '0';
export const VERIFICATION_LEVEL_1 = '1';
export const VERIFICATION_LEVEL_2 = '2';
